import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { tap, finalize, catchError } from 'rxjs/operators';
import { AdjustmentStore } from '../../service/adjustment.store';
import { Adjustment } from '../../models/adjustment';
import { PioneerValidators } from '../../../shared/utils/pioneer.validators';
import { AdjustmentTypeStore } from '../../service/adjustment-type/adjustment-type.store';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'pioneer-add-adjustment',
  templateUrl: './add-adjustment.component.html',
  styleUrls: ['./add-adjustment.component.css']
})
export class AddAdjustmentComponent implements OnInit {

  @Input()
  event: OnyxEvent;

  @Output()
  cancel = new EventEmitter();

  @Output()
  save = new EventEmitter();

  adjustmentForm: FormGroup;

  adjustmentFormList: Array<FormGroup> = [];
  newAdjustmentForm: FormGroup;

  get adjustmentStore(): AdjustmentStore {
    return this._adjustmentStore;
  }

  get adjustmentTypeStore(): AdjustmentTypeStore {
    return this._adjustmentTypeStore;
  }

  private getFormControlValue(adjustmentForm: FormGroup, name: string): any {
    return adjustmentForm ? adjustmentForm.get(name).value : null;
  }

  constructor(
    private formBuilder: FormBuilder,
    private _adjustmentStore: AdjustmentStore,
    private _adjustmentTypeStore: AdjustmentTypeStore
  ) { }

  ngOnInit() {
    if (!this.event) {
      throw new Error('The "event" attribute must be specified to use the AddAdjustmentComponent component');
    }

    this.initForm();
  }

  public saveClick() {
    let obs$;
    this.adjustmentFormList.forEach(adjustmentForm => {
      obs$ = this.saveForm(adjustmentForm);
    });

    return obs$;
  }

  private saveForm(adjustmentForm: FormGroup) {
    adjustmentForm.disable();

    const adjustment = new Adjustment({
      eventId: this.event.eventId,
      adjustmentAmount: this.getFormControlValue(adjustmentForm, 'amount'),
      adjustmentType: this.getFormControlValue(adjustmentForm, 'type'),
      description: this.getFormControlValue(adjustmentForm, 'description'),
      adjustmentSpendAmount: this.getFormControlValue(adjustmentForm, 'spendAmount'),
      adjustmentCommRate: this.getFormControlValue(adjustmentForm, 'commRate')
    });

    const obs$ = this.adjustmentStore.addAdjustment(adjustment).pipe(
      tap(() => {
        adjustmentForm.reset();
        this.adjustmentStore.loadAdjustments(this.event.eventId).subscribe();
        this.save.emit();
      }),
      catchError(() => {
        return Observable.of(null);
      }),
      finalize(() => {
        adjustmentForm.enable();
      })
    );
    obs$.subscribe();
    return obs$;
  }

  cancelClick() {
    this.adjustmentFormList.forEach(adjustmentForm => {
      adjustmentForm.reset();
    });
    this.cancel.emit();
  }

  disableSave() {
    let disable = false;
    this.adjustmentFormList.forEach(adjustmentForm => {
      if (this.disableSaveForm(adjustmentForm)) {
        disable = true;
        return;
      }
    });
    return disable;
  }

  private disableSaveForm(adjustmentForm: FormGroup) {
    let disable: boolean;
    if (adjustmentForm) {
      disable = !adjustmentForm.valid;
    } else {
      disable = true;
    }
    return disable;
  }

  isCredit(): boolean {
    return true;
  }

  private initForm() {
    const newAdjustmentForm: FormGroup = this.getNewAdjustmentForm();

    this.adjustmentFormList.push(newAdjustmentForm);
  }

  private getNewAdjustmentForm(): FormGroup {
    let newForm: FormGroup = this.formBuilder.group({
      'amount': [null, [Validators.required, PioneerValidators.isValidAmountInRangeInclNegative(-9999999999999.99, 9999999999999.99)]],
      'type': [null, [Validators.required]],
      'description': [null, [ Validators.maxLength(255) ]],
      'spendAmount': [null, [PioneerValidators.isValidAmountInRangeInclNegative(-9999999999999.99, 9999999999999.99)]],
      'commRate': [null, [ PioneerValidators.range(0, 100), PioneerValidators.isInteger ]]
    }, {
      validator: PioneerValidators.isAmountEqualToSpendAmountByCommRate('amount', 'spendAmount', 'commRate')
    });

    newForm = this.addEvent(newForm, 'spendAmount');
    newForm = this.addEvent(newForm, 'commRate');

    return newForm;
  }

  private addEvent(currentForm: FormGroup, fieldName: string): FormGroup {
    currentForm.controls[fieldName].valueChanges.subscribe(value => {
      if (value) {
        this.calculateAmount(currentForm);
      }
    });

    return currentForm;
  }

  addRow() {
    this.newAdjustmentForm = this.getNewAdjustmentForm();
    this.adjustmentFormList.push(this.newAdjustmentForm);
  }

  deleteRow(index: number) {
    if (this.adjustmentFormList.length === 1) {
      return false;
    } else {
      this.adjustmentFormList.splice(index, 1);
      return true;
    }
  }

  calculateAmount(currentForm: FormGroup) {
    if (currentForm && currentForm instanceof FormGroup) {
      if (currentForm.get('spendAmount').value && currentForm.get('commRate').value) {
        const spend = currentForm.get('spendAmount').value;
        const rate = currentForm.get('commRate').value;

        if (spend && rate) {
          const amount = Number((spend * rate / 100).toFixed(2));
          currentForm.get('amount').setValue(amount);
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/add-adjustment/add-adjustment.component.ts